<template>
  <div class="rate-fraud-free-banner overflow-hidden pa-6">
    <span
      class="rate-fraud-free-banner__overlay"
      aria-hidden="false"
    />
    <span class="d-inline-flex flex-wrap gc-1 position-relative d-flex text-h6 bg-gray-0--text">
      {{ t('Сообщите о заказном отзыве на сайте ПроДокторов', options) }}
      <span class="text-no-wrap">
        {{ `${t('и получите до', options)} ${cashReward}` }}
      </span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  cashReward: string
}>()
</script>

<style lang="scss" scoped>
.rate-fraud-free-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('/static/_v1/pd/banners/rate-fraud-free-banner.jpeg') no-repeat center / cover;
  position: relative;

  &__overlay {
    background: rgba(54, 54, 54, 0.6);
    position: absolute;
    inset: 0;
  }
}
</style>
